import * as yup from "yup";

export const createPaymentMethodSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    provider: v.string().required(),
  });
};
